import { ICON__check } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { assert_false } from '@shared/asserts/utils_asserts';

export function G_BUTTON__use_selected_image_in_field() {
  /*
   * STORE
   */
  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_general__ui_disabled, g_image_edit__field, g_image_edit__select__image_asset } = use_slice_ui([
    'g_general__ui_disabled',
    'g_image_edit__field',
    'g_image_edit__select__image_asset',
  ]);

  /*
   * EVENTS
   */
  async function onClick(e: React.MouseEvent) {
    assert_false(g_image_edit__field.is_stub());
    assert_false(g_image_edit__select__image_asset.is_stub());

    let field_new = g_image_edit__field.clone();
    field_new.image__asset_use(g_image_edit__select__image_asset);

    await UTILS__graph_data.update_field(generation_current.tool.graph, field_new);
  }

  /*
   * METHODS
   */

  function is_disabled() {
    return (
      g_general__ui_disabled ||
      g_image_edit__select__image_asset.is_stub() ||
      g_image_edit__field.hash_sha256_content == g_image_edit__select__image_asset.hash_sha256_content
    );
  }

  /*
   * HTML
   */

  if (g_image_edit__field.is_stub()) return <PLACEHOLDER_bar_line />;

  return (
    <UI_PRIMITIVE__button disabled={is_disabled()} {...{ onClick }} size="full-6" variant="outline-on-bar">
      <ICON__check className="!size-3" />
      Use selected image
    </UI_PRIMITIVE__button>
  );
}
